// src/coverData.ts
import React from "react";

// --- IMPORTY POJEDYNCZE ---
import Wzor25 from "./covers/Wzor25";
import Wz126 from "./covers/Wz126";

// --- IMPORTY BAŚNIE ---
import Wz01 from "./covers/Basnie250x300/Wz01"; 
import Wz02 from "./covers/Basnie250x300/Wz02"; 
import Basnie3 from "./covers/Basnie250x300/Basnie3"; 

import { Basnie4 } from "./covers/Basnie250x300/Basnie4";
import { Basnie5 } from "./covers/Basnie250x300/Basnie5";
import { Basnie6 } from "./covers/Basnie250x300/Basnie6";
import { Basnie7 } from "./covers/Basnie250x300/Basnie7";
import { Basnie8 } from "./covers/Basnie250x300/Basnie8";
import { Basnie9 } from "./covers/Basnie250x300/Basnie9";
import { Basnie10 } from "./covers/Basnie250x300/Basnie10";
import { Basnie11 } from "./covers/Basnie250x300/Basnie11";
import { Basnie12 } from "./covers/Basnie250x300/Basnie12";
import { Basnie13 } from "./covers/Basnie250x300/Basnie13";
import { Basnie14 } from "./covers/Basnie250x300/Basnie14";
import { Basnie15 } from "./covers/Basnie250x300/Basnie15";
import { Basnie16 } from "./covers/Basnie250x300/Basnie16";
import { Basnie17 } from "./covers/Basnie250x300/Basnie17";
import { Basnie18 } from "./covers/Basnie250x300/Basnie18";
import { Basnie19 } from "./covers/Basnie250x300/Basnie19";
import { Basnie20 } from "./covers/Basnie250x300/Basnie20";
import { Basnie21 } from "./covers/Basnie250x300/Basnie21";
import { Basnie22 } from "./covers/Basnie250x300/Basnie22";
import { Basnie23 } from "./covers/Basnie250x300/Basnie23";
import { Basnie24 } from "./covers/Basnie250x300/Basnie24";
import { Basnie25 } from "./covers/Basnie250x300/Basnie25";
import { Basnie26 } from "./covers/Basnie250x300/Basnie26";
import { Basnie27 } from "./covers/Basnie250x300/Basnie27";
import { Basnie28 } from "./covers/Basnie250x300/Basnie28";
import { Basnie29 } from "./covers/Basnie250x300/Basnie29";
import { Basnie30 } from "./covers/Basnie250x300/Basnie30";
import { Basnie31 } from "./covers/Basnie250x300/Basnie31";
import { Basnie32 } from "./covers/Basnie250x300/Basnie32";
import { Basnie33 } from "./covers/Basnie250x300/Basnie33";
import { Basnie34 } from "./covers/Basnie250x300/Basnie34";
import { Basnie35 } from "./covers/Basnie250x300/Basnie35";
import { Basnie36 } from "./covers/Basnie250x300/Basnie36";
import { Basnie37 } from "./covers/Basnie250x300/Basnie37";
import { Basnie38 } from "./covers/Basnie250x300/Basnie38";
import { Basnie39 } from "./covers/Basnie250x300/Basnie39";
import { Basnie40 } from "./covers/Basnie250x300/Basnie40";
import { Basnie41 } from "./covers/Basnie250x300/Basnie41";
import { Basnie42 } from "./covers/Basnie250x300/Basnie42";
import { Basnie43 } from "./covers/Basnie250x300/Basnie43";
import { Basnie44 } from "./covers/Basnie250x300/Basnie44";
import { Basnie45 } from "./covers/Basnie250x300/Basnie45";
import { Basnie46 } from "./covers/Basnie250x300/Basnie46";
import { Basnie47 } from "./covers/Basnie250x300/Basnie47";
import { Basnie48 } from "./covers/Basnie250x300/Basnie48";

// --- IMPORTY NOWE ---
import Sw01 from "./covers/nowe/Sw01"; 
import { Sw02 } from "./covers/nowe/Sw02";
import { Sw03 } from "./covers/nowe/Sw03";
import { Sw04 } from "./covers/nowe/Sw04";
import { Sw05 } from "./covers/nowe/Sw05";
import { Sw06 } from "./covers/nowe/Sw06";

// --- IMPORTY DBCSS ---
import { Jc01 } from "./covers/DBCSS10-20-WHITE-BABY-260x263/Jc01";
import { Jc02 } from "./covers/DBCSS10-20-WHITE-BABY-260x263/Jc02";
import { Jc03 } from "./covers/DBCSS10-20-WHITE-BABY-260x263/Jc03";
import { Jc04 } from "./covers/DBCSS10-20-WHITE-BABY-260x263/Jc04";
import { Jc05 } from "./covers/DBCSS10-20-WHITE-BABY-260x263/Jc05";

// --- IMPORTY KD46200 ---
import { Ac01 } from "./covers/KD46200WHITE-BABY-215x223mm/Ac01";
import { Ac02 } from "./covers/KD46200WHITE-BABY-215x223mm/Ac02";
import { Ac03 } from "./covers/KD46200WHITE-BABY-215x223mm/Ac03";
import { Ac04 } from "./covers/KD46200WHITE-BABY-215x223mm/Ac04";
import { Ad1 } from "./covers/KD46200WHITE-BABY-215x223mm/AD1";
import { Ad2 } from "./covers/KD46200WHITE-BABY-215x223mm/AD2";
import { Ad3 } from "./covers/KD46200WHITE-BABY-215x223mm/AD3";
import { Ad4 } from "./covers/KD46200WHITE-BABY-215x223mm/AD4";
import { Ad5 } from "./covers/KD46200WHITE-BABY-215x223mm/AD5";
import { Ad6 } from "./covers/KD46200WHITE-BABY-215x223mm/AD6";
import { Ad7 } from "./covers/KD46200WHITE-BABY-215x223mm/AD7";
import { Ad8 } from "./covers/KD46200WHITE-BABY-215x223mm/AD8";
import { Ad9 } from "./covers/KD46200WHITE-BABY-215x223mm/AD9";
import { Ad10 } from "./covers/KD46200WHITE-BABY-215x223mm/AD10";
import { Ad11 } from "./covers/KD46200WHITE-BABY-215x223mm/AD11";
import { Ad12 } from "./covers/KD46200WHITE-BABY-215x223mm/AD12";
import { Ad13 } from "./covers/KD46200WHITE-BABY-215x223mm/AD13";
import { Ad14 } from "./covers/KD46200WHITE-BABY-215x223mm/AD14";
import { Ad15 } from "./covers/KD46200WHITE-BABY-215x223mm/AD15";
import { Ad16 } from "./covers/KD46200WHITE-BABY-215x223mm/AD16";
import { Ad17 } from "./covers/KD46200WHITE-BABY-215x223mm/AD17";
import { Ad18 } from "./covers/KD46200WHITE-BABY-215x223mm/AD18";
import { Ad19 } from "./covers/KD46200WHITE-BABY-215x223mm/AD19";
import { Ad20 } from "./covers/KD46200WHITE-BABY-215x223mm/AD20";
import { Ad21 } from "./covers/KD46200WHITE-BABY-215x223mm/AD21";
import { Ad22 } from "./covers/KD46200WHITE-BABY-215x223mm/AD22";
import { Ad23 } from "./covers/KD46200WHITE-BABY-215x223mm/AD23";
import { Ad24 } from "./covers/KD46200WHITE-BABY-215x223mm/AD24";
import { Ad25 } from "./covers/KD46200WHITE-BABY-215x223mm/AD25";
import { Ad26 } from "./covers/KD46200WHITE-BABY-215x223mm/AD26";
import { Ad27 } from "./covers/KD46200WHITE-BABY-215x223mm/AD27";
import { Ad28 } from "./covers/KD46200WHITE-BABY-215x223mm/AD28";
import { Ad29 } from "./covers/KD46200WHITE-BABY-215x223mm/AD29";
import { Ad30 } from "./covers/KD46200WHITE-BABY-215x223mm/AD30";
import { Ad31 } from "./covers/KD46200WHITE-BABY-215x223mm/AD31";
import { Ad32 } from "./covers/KD46200WHITE-BABY-215x223mm/AD32";
import { Ad33 } from "./covers/KD46200WHITE-BABY-215x223mm/AD33";
import { Ad34 } from "./covers/KD46200WHITE-BABY-215x223mm/AD34";
import { Ad35 } from "./covers/KD46200WHITE-BABY-215x223mm/AD35";
import { Ad36 } from "./covers/KD46200WHITE-BABY-215x223mm/AD36";
import { Ad37 } from "./covers/KD46200WHITE-BABY-215x223mm/AD37";
import { Ad38 } from "./covers/KD46200WHITE-BABY-215x223mm/AD38";
import { Ad39 } from "./covers/KD46200WHITE-BABY-215x223mm/AD39";
import { Ad40 } from "./covers/KD46200WHITE-BABY-215x223mm/AD40";
import { Ad41 } from "./covers/KD46200WHITE-BABY-215x223mm/AD41";
import { Ad42 } from "./covers/KD46200WHITE-BABY-215x223mm/AD42";
import { Ad43 } from "./covers/KD46200WHITE-BABY-215x223mm/AD43";
import { Ad44 } from "./covers/KD46200WHITE-BABY-215x223mm/AD44";
import { Ad45 } from "./covers/KD46200WHITE-BABY-215x223mm/AD45";
import { Ad46 } from "./covers/KD46200WHITE-BABY-215x223mm/AD46";
import { Ad47 } from "./covers/KD46200WHITE-BABY-215x223mm/AD47";
import { Ad48 } from "./covers/KD46200WHITE-BABY-215x223mm/AD48";
import { Ad49 } from "./covers/KD46200WHITE-BABY-215x223mm/AD49";
import { Ad50 } from "./covers/KD46200WHITE-BABY-215x223mm/AD50";
import { Ad51 } from "./covers/KD46200WHITE-BABY-215x223mm/AD51";
import { Ad52 } from "./covers/KD46200WHITE-BABY-215x223mm/AD52";
import { Ad53 } from "./covers/KD46200WHITE-BABY-215x223mm/AD53";
import { Ad54 } from "./covers/KD46200WHITE-BABY-215x223mm/AD54";
import { Ad56 } from "./covers/KD46200WHITE-BABY-215x223mm/AD56";
import { Ad57 } from "./covers/KD46200WHITE-BABY-215x223mm/AD57";
import { Ad58 } from "./covers/KD46200WHITE-BABY-215x223mm/AD58";
import { Ad59 } from "./covers/KD46200WHITE-BABY-215x223mm/AD59";
import { Ad60 } from "./covers/KD46200WHITE-BABY-215x223mm/AD60";
import { Ad61 } from "./covers/KD46200WHITE-BABY-215x223mm/AD61";
import { Ad62 } from "./covers/KD46200WHITE-BABY-215x223mm/AD62";
import { Ad63 } from "./covers/KD46200WHITE-BABY-215x223mm/AD63";
import { Ad64 } from "./covers/KD46200WHITE-BABY-215x223mm/AD64";

// --- IMPORTY KD68200 ---
import { Md01 } from "./covers/KD68200WHITE_dzieci_250x353/Md01";
import { Md02 } from "./covers/KD68200WHITE_dzieci_250x353/Md02";
import { Md03 } from "./covers/KD68200WHITE_dzieci_250x353/Md03";
import { Md04 } from "./covers/KD68200WHITE_dzieci_250x353/Md04";
import { Md05 } from "./covers/KD68200WHITE_dzieci_250x353/Md05";
import { Md06 } from "./covers/KD68200WHITE_dzieci_250x353/Md06";
import { Md07 } from "./covers/KD68200WHITE_dzieci_250x353/Md07";
import { Md08 } from "./covers/KD68200WHITE_dzieci_250x353/Md08";
import { Md09 } from "./covers/KD68200WHITE_dzieci_250x353/Md09";
import { Md10 } from "./covers/KD68200WHITE_dzieci_250x353/Md10";
import { Md11 } from "./covers/KD68200WHITE_dzieci_250x353/Md11";
import { Md12 } from "./covers/KD68200WHITE_dzieci_250x353/Md12";
import { Md13 } from "./covers/KD68200WHITE_dzieci_250x353/Md13";
import { Md14 } from "./covers/KD68200WHITE_dzieci_250x353/Md14";
import { Md15 } from "./covers/KD68200WHITE_dzieci_250x353/Md15";
import { Md16 } from "./covers/KD68200WHITE_dzieci_250x353/Md16";
import { Md17 } from "./covers/KD68200WHITE_dzieci_250x353/Md17";
import { Md18 } from "./covers/KD68200WHITE_dzieci_250x353/Md18";
import { Md19 } from "./covers/KD68200WHITE_dzieci_250x353/Md19";
import { Md20 } from "./covers/KD68200WHITE_dzieci_250x353/Md20";

// --- IMPORTY KD57200 ---
import { Kd01 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd01";
import { Kd02 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd02";
import { Kd03 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd03";
import { Kd04 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd04";
import { Kd05 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd05";
import { Kd06 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd06";
import { Kd07 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd07";
import { Kd08 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd08";
import { Kd09 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd09";
import { Kd10 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd10";
import { Kd11 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd11";
import { Kd12 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd12";
import { Kd13 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd13";
import { Kd15 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd15";
import { Kd16 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd16";
import { Kd17 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd17";
import { Kd18 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd18";
import { Kd19 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd19";
import { Kd20 } from "./covers/KD57200_WHITE_dzieci_223x250/Kd20";

// --- IMPORTY KD463002 ---
import { Wz21 } from "./covers/KD463002WHITE_190x253/WZ21";
import { Wz22 } from "./covers/KD463002WHITE_190x253/WZ22";
import { Wz23 } from "./covers/KD463002WHITE_190x253/WZ23";
import { Wz24 } from "./covers/KD463002WHITE_190x253/WZ24";
import { Wz25 } from "./covers/KD463002WHITE_190x253/WZ25";
import { Wz26 } from "./covers/KD463002WHITE_190x253/WZ26";
import { Wz27 } from "./covers/KD463002WHITE_190x253/WZ27";
import { Wz28 } from "./covers/KD463002WHITE_190x253/WZ28";
import { Wz29 } from "./covers/KD463002WHITE_190x253/WZ29";
import { Wz30 } from "./covers/KD463002WHITE_190x253/WZ30";
import { Wz31 } from "./covers/KD463002WHITE_190x253/WZ31";
import { Wz32 } from "./covers/KD463002WHITE_190x253/WZ32";
import { Wz33 } from "./covers/KD463002WHITE_190x253/WZ33";
import { Wz34 } from "./covers/KD463002WHITE_190x253/WZ34";
import { Wz35 } from "./covers/KD463002WHITE_190x253/WZ35";
import { Wz36 } from "./covers/KD463002WHITE_190x253/WZ36";
import { Wz112 } from "./covers/KD463002WHITE_190x253/WZ112";
import { Wz113 } from "./covers/KD463002WHITE_190x253/WZ113";
import { Wz114 } from "./covers/KD463002WHITE_190x253/WZ114";
import { Wz115 } from "./covers/KD463002WHITE_190x253/WZ115";
import { Wz116 } from "./covers/KD463002WHITE_190x253/WZ116";
import { Wz117 } from "./covers/KD463002WHITE_190x253/WZ117";
import { Wz118 } from "./covers/KD463002WHITE_190x253/WZ118";
import { Wz119 } from "./covers/KD463002WHITE_190x253/WZ119";
import { Wz120 } from "./covers/KD463002WHITE_190x253/WZ120";
import { Wz121 } from "./covers/KD463002WHITE_190x253/WZ121";
import { Wz122 } from "./covers/KD463002WHITE_190x253/WZ122";
import { Wz123 } from "./covers/KD463002WHITE_190x253/WZ123";
import { Wz124 } from "./covers/KD463002WHITE_190x253/WZ124";
import { Wz125 } from "./covers/KD463002WHITE_190x253/WZ125";
import { Wz126 as Wz126Kd463002 } from "./covers/KD463002WHITE_190x253/WZ126";
import { Wz127 } from "./covers/KD463002WHITE_190x253/WZ127";
import { Wz128 } from "./covers/KD463002WHITE_190x253/WZ128";
import { Wz129 } from "./covers/KD463002WHITE_190x253/WZ129";
import { Wz130 } from "./covers/KD463002WHITE_190x253/WZ130";
import { Wz131 } from "./covers/KD463002WHITE_190x253/WZ131";
import { Wz132 } from "./covers/KD463002WHITE_190x253/WZ132";
import { Wz133 } from "./covers/KD463002WHITE_190x253/WZ133";
import { Wz134 } from "./covers/KD463002WHITE_190x253/WZ134";
import { Wz135 } from "./covers/KD463002WHITE_190x253/WZ135";
import { Wz136 } from "./covers/KD463002WHITE_190x253/WZ136";
import { Wz137 } from "./covers/KD463002WHITE_190x253/WZ137";
import { Wz138 } from "./covers/KD463002WHITE_190x253/WZ138";
import { Wz139 } from "./covers/KD463002WHITE_190x253/WZ139";
import { Wz140 } from "./covers/KD463002WHITE_190x253/WZ140";

// --- IMPORTY KD46500 ---
import { Cd01 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD01";
import { Cd02 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD02";
import { Cd03 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD03";
import { Cd04 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD04";
import { Cd05 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD05";
import { Cd06 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD06";
import { Cd07 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD07";
import { Cd08 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD08";
import { Cd09 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD09";
import { Cd10 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD10";
import { Cd11 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD11";
import { Cd12 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD12";
import { Cd13 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD13";
import { Cd14 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD14";
import { Cd15 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD15";
import { Cd16 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD16";
import { Cd17 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD17";
import { Cd18 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD18";
import { Cd19 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD19";
import { Cd20 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD20";
import { Cd21 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD21";
import { Cd22 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD22";
import { Cd24 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD24";
import { Cd25 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD25";
import { Cd26 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD26";
import { Cd27 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD27";
import { Cd28 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD28";
import { Cd29 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD29";
import { Cd30 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD30";
import { Cd31 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD31";
import { Cd32 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD32";
import { Cd33 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD33";
import { Cd34 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD34";
import { Cd35 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD35";
import { Cd36 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD36";
import { Cd37 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD37";
import { Cd38 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD38";
import { Cd39 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD39";
import { Cd40 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD40";
import { Cd41 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD41";
import { Cd42 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD42";
import { Cd43 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD43";
import { Cd44 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD44";
import { Cd45 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD45";
import { Cd46 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD46";
import { Cd47 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD47";
import { Cd48 } from "./covers/KD46500_600_WHITE_BABY_330x333/CD48";

// --- BAŚNIE ANDERSEN 213x268 ---
import { An1 } from "./covers/BasnieAndersen213x268/AN1";
import { An2 } from "./covers/BasnieAndersen213x268/AN2";
import { An3 } from "./covers/BasnieAndersen213x268/AN3";
import { An4 } from "./covers/BasnieAndersen213x268/AN4";
import { An5 } from "./covers/BasnieAndersen213x268/AN5";
import { An6 } from "./covers/BasnieAndersen213x268/AN6";
import { An7 } from "./covers/BasnieAndersen213x268/AN7";
import { An8 } from "./covers/BasnieAndersen213x268/AN8";
import { An9 } from "./covers/BasnieAndersen213x268/AN9";
import { An10 } from "./covers/BasnieAndersen213x268/AN10";
import { An11 } from "./covers/BasnieAndersen213x268/AN11";
import { An12 } from "./covers/BasnieAndersen213x268/AN12";
import { An13 } from "./covers/BasnieAndersen213x268/AN13";
import { An14 } from "./covers/BasnieAndersen213x268/AN14";

// --- DEFINICJE TYPÓW ---

// Definicja pojedynczej okładki
export interface CoverConfig {
  id: string;
  // React.ComponentType<any> pozwala na przekazanie dowolnego komponentu React
  component: React.ComponentType; 
  label: string;
  pathOverride?: string; // Opcjonalne pole
}

// Definicja kategorii
export interface CategoryConfig {
  id: string;
  title: string;
  basePath: string;
  thumbnailRatio: {
    width: number;
    height: number;
  };
  covers: CoverConfig[];
}

export const categories: CategoryConfig[] = [
  // 1. POJEDYNCZE WZORY
  {
    id: "pojedyncze",
    title: "Pojedyncze Wzory",
    basePath: "", 
    thumbnailRatio: { width: 200, height: 200 }, 
    covers: [
      { id: "wzor25", component: Wzor25, label: "Wzór 25", pathOverride: "/wzor25" },
      { id: "wz126", component: Wz126, label: "Wzór 126", pathOverride: "/wz126" },
    ],
  },

  // 2. BAŚNIE (250x300)
  {
    id: "basnie",
    title: "Baśnie (250x300)",
    basePath: "/Basnie250x300",
    thumbnailRatio: { width: 250, height: 300 },
    covers: [
      { id: "Basnie1", component: Wz01, label: "Baśń 1" },
      { id: "Basnie2", component: Wz02, label: "Baśń 2" },
      { id: "Basnie3", component: Basnie3, label: "Baśń 3" },
      { id: "Basnie4", component: Basnie4, label: "Baśń 4" },
      { id: "Basnie5", component: Basnie5, label: "Baśń 5" },
      { id: "Basnie6", component: Basnie6, label: "Baśń 6" },
      { id: "Basnie7", component: Basnie7, label: "Baśń 7" },
      { id: "Basnie8", component: Basnie8, label: "Baśń 8" },
      { id: "Basnie9", component: Basnie9, label: "Baśń 9" },
      { id: "Basnie10", component: Basnie10, label: "Baśń 10" },
      { id: "Basnie11", component: Basnie11, label: "Baśń 11" },
      { id: "Basnie12", component: Basnie12, label: "Baśń 12" },
      { id: "Basnie13", component: Basnie13, label: "Baśń 13" },
      { id: "Basnie14", component: Basnie14, label: "Baśń 14" },
      { id: "Basnie15", component: Basnie15, label: "Baśń 15" },
      { id: "Basnie16", component: Basnie16, label: "Baśń 16" },
      { id: "Basnie17", component: Basnie17, label: "Baśń 17" },
      { id: "Basnie18", component: Basnie18, label: "Baśń 18" },
      { id: "Basnie19", component: Basnie19, label: "Baśń 19" },
      { id: "Basnie20", component: Basnie20, label: "Baśń 20" },
      { id: "Basnie21", component: Basnie21, label: "Baśń 21" },
      { id: "Basnie22", component: Basnie22, label: "Baśń 22" },
      { id: "Basnie23", component: Basnie23, label: "Baśń 23" },
      { id: "Basnie24", component: Basnie24, label: "Baśń 24" },
      { id: "Basnie25", component: Basnie25, label: "Baśń 25" },
      { id: "Basnie26", component: Basnie26, label: "Baśń 26" },
      { id: "Basnie27", component: Basnie27, label: "Baśń 27" },
      { id: "Basnie28", component: Basnie28, label: "Baśń 28" },
      { id: "Basnie29", component: Basnie29, label: "Baśń 29" },
      { id: "Basnie30", component: Basnie30, label: "Baśń 30" },
      { id: "Basnie31", component: Basnie31, label: "Baśń 31" },
      { id: "Basnie32", component: Basnie32, label: "Baśń 32" },
      { id: "Basnie33", component: Basnie33, label: "Baśń 33" },
      { id: "Basnie34", component: Basnie34, label: "Baśń 34" },
      { id: "Basnie35", component: Basnie35, label: "Baśń 35" },
      { id: "Basnie36", component: Basnie36, label: "Baśń 36" },
      { id: "Basnie37", component: Basnie37, label: "Baśń 37" },
      { id: "Basnie38", component: Basnie38, label: "Baśń 38" },
      { id: "Basnie39", component: Basnie39, label: "Baśń 39" },
      { id: "Basnie40", component: Basnie40, label: "Baśń 40" },
      { id: "Basnie41", component: Basnie41, label: "Baśń 41" },
      { id: "Basnie42", component: Basnie42, label: "Baśń 42" },
      { id: "Basnie43", component: Basnie43, label: "Baśń 43" },
      { id: "Basnie44", component: Basnie44, label: "Baśń 44" },
      { id: "Basnie45", component: Basnie45, label: "Baśń 45" },
      { id: "Basnie46", component: Basnie46, label: "Baśń 46" },
      { id: "Basnie47", component: Basnie47, label: "Baśń 47" },
      { id: "Basnie48", component: Basnie48, label: "Baśń 48" },
      // { id: "Basnie52", component: Basnie52, label: "Baśń 52" },
      { id: "Basnie53", component: Sw01, label: "Baśń 53" },
      { id: "Basnie54", component: Sw02, label: "Baśń 54" },
      { id: "Basnie55", component: Sw03, label: "Baśń 55" },
      { id: "Basnie56", component: Sw04, label: "Baśń 56" },
      { id: "Basnie57", component: Sw05, label: "Baśń 57" },
      { id: "Basnie58", component: Sw06, label: "Baśń 58" },
    ],
  },

  // 3. BAŚNIE ANDERSEN 213x268 (AN7: PDF 215x265 mm, tło rozciągnięte do 213x268)
  {
    id: "andersen",
    title: "Baśnie Andersen (213x268)",
    basePath: "/BasnieAndersen213x268",
    thumbnailRatio: { width: 213, height: 268 },
    covers: [
      { id: "an1", component: An1, label: "Andersen 1" },
      { id: "an2", component: An2, label: "Andersen 2" },
      { id: "an3", component: An3, label: "Andersen 3" },
      { id: "an4", component: An4, label: "Andersen 4" },
      { id: "an5", component: An5, label: "Andersen 5" },
      { id: "an6", component: An6, label: "Andersen 6" },
      { id: "an7", component: An7, label: "Andersen 7" },
      { id: "an8", component: An8, label: "Andersen 8" },
      { id: "an9", component: An9, label: "Andersen 9" },
      { id: "an10", component: An10, label: "Andersen 10" },
      { id: "an11", component: An11, label: "Andersen 11" },
      { id: "an12", component: An12, label: "Andersen 12" },
      { id: "an13", component: An13, label: "Andersen 13" },
      { id: "an14", component: An14, label: "Andersen 14" },
    ],
  },

  // 4. DBCSS WHITE BABY
  {
    id: "dbcss",
    title: "DBCSS White Baby (260x263)",
    basePath: "/DBCSS10-20-WHITE-BABY-260x263",
    thumbnailRatio: { width: 260, height: 263 },
    covers: [
      { id: "jc01", component: Jc01, label: "JC 01" },
      { id: "jc02", component: Jc02, label: "JC 02" },
      { id: "jc03", component: Jc03, label: "JC 03" },
      { id: "jc04", component: Jc04, label: "JC 04" },
      { id: "jc05", component: Jc05, label: "JC 05" },
    ],
  },

  // 5. KD46200 WHITE BABY (rozmiar strony z PDF: 215x223, AD2/20/28/39/46/47/52 220x220, AD33/38/48 215x220; AD55 pominięty — pusty PDF)
  {
    id: "kd46200",
    title: "KD46200 White Baby (215x223)",
    basePath: "/KD46200WHITE-BABY-215x223mm",
    thumbnailRatio: { width: 215, height: 223 },
    covers: [
      { id: "ac01", component: Ac01, label: "AC 01" },
      { id: "ac02", component: Ac02, label: "AC 02" },
      { id: "ac03", component: Ac03, label: "AC 03" },
      { id: "ac04", component: Ac04, label: "AC 04" },
      { id: "ad1", component: Ad1, label: "AD 1" },
      { id: "ad2", component: Ad2, label: "AD 2" },
      { id: "ad3", component: Ad3, label: "AD 3" },
      { id: "ad4", component: Ad4, label: "AD 4" },
      { id: "ad5", component: Ad5, label: "AD 5" },
      { id: "ad6", component: Ad6, label: "AD 6" },
      { id: "ad7", component: Ad7, label: "AD 7" },
      { id: "ad8", component: Ad8, label: "AD 8" },
      { id: "ad9", component: Ad9, label: "AD 9" },
      { id: "ad10", component: Ad10, label: "AD 10" },
      { id: "ad11", component: Ad11, label: "AD 11" },
      { id: "ad12", component: Ad12, label: "AD 12" },
      { id: "ad13", component: Ad13, label: "AD 13" },
      { id: "ad14", component: Ad14, label: "AD 14" },
      { id: "ad15", component: Ad15, label: "AD 15" },
      { id: "ad16", component: Ad16, label: "AD 16" },
      { id: "ad17", component: Ad17, label: "AD 17" },
      { id: "ad18", component: Ad18, label: "AD 18" },
      { id: "ad19", component: Ad19, label: "AD 19" },
      { id: "ad20", component: Ad20, label: "AD 20" },
      { id: "ad21", component: Ad21, label: "AD 21" },
      { id: "ad22", component: Ad22, label: "AD 22" },
      { id: "ad23", component: Ad23, label: "AD 23" },
      { id: "ad24", component: Ad24, label: "AD 24" },
      { id: "ad25", component: Ad25, label: "AD 25" },
      { id: "ad26", component: Ad26, label: "AD 26" },
      { id: "ad27", component: Ad27, label: "AD 27" },
      { id: "ad28", component: Ad28, label: "AD 28" },
      { id: "ad29", component: Ad29, label: "AD 29" },
      { id: "ad30", component: Ad30, label: "AD 30" },
      { id: "ad31", component: Ad31, label: "AD 31" },
      { id: "ad32", component: Ad32, label: "AD 32" },
      { id: "ad33", component: Ad33, label: "AD 33" },
      { id: "ad34", component: Ad34, label: "AD 34" },
      { id: "ad35", component: Ad35, label: "AD 35" },
      { id: "ad36", component: Ad36, label: "AD 36" },
      { id: "ad37", component: Ad37, label: "AD 37" },
      { id: "ad38", component: Ad38, label: "AD 38" },
      { id: "ad39", component: Ad39, label: "AD 39" },
      { id: "ad40", component: Ad40, label: "AD 40" },
      { id: "ad41", component: Ad41, label: "AD 41" },
      { id: "ad42", component: Ad42, label: "AD 42" },
      { id: "ad43", component: Ad43, label: "AD 43" },
      { id: "ad44", component: Ad44, label: "AD 44" },
      { id: "ad45", component: Ad45, label: "AD 45" },
      { id: "ad46", component: Ad46, label: "AD 46" },
      { id: "ad47", component: Ad47, label: "AD 47" },
      { id: "ad48", component: Ad48, label: "AD 48" },
      { id: "ad49", component: Ad49, label: "AD 49" },
      { id: "ad50", component: Ad50, label: "AD 50" },
      { id: "ad51", component: Ad51, label: "AD 51" },
      { id: "ad52", component: Ad52, label: "AD 52" },
      { id: "ad53", component: Ad53, label: "AD 53" },
      { id: "ad54", component: Ad54, label: "AD 54" },
      { id: "ad56", component: Ad56, label: "AD 56" },
      { id: "ad57", component: Ad57, label: "AD 57" },
      { id: "ad58", component: Ad58, label: "AD 58" },
      { id: "ad59", component: Ad59, label: "AD 59" },
      { id: "ad60", component: Ad60, label: "AD 60" },
      { id: "ad61", component: Ad61, label: "AD 61" },
      { id: "ad62", component: Ad62, label: "AD 62" },
      { id: "ad63", component: Ad63, label: "AD 63" },
      { id: "ad64", component: Ad64, label: "AD 64" },
    ],
  },

  // 6. KD68200 WHITE DZIECI
  {
    id: "kd68200",
    title: "KD68200 White Dzieci (250x353)",
    basePath: "/KD68200WHITE_dzieci_250x353",
    thumbnailRatio: { width: 250, height: 353 },
    covers: [
      { id: "md01", component: Md01, label: "MD 01" },
      { id: "md02", component: Md02, label: "MD 02" },
      { id: "md03", component: Md03, label: "MD 03" },
      { id: "md04", component: Md04, label: "MD 04" },
      { id: "md05", component: Md05, label: "MD 05" },
      { id: "md06", component: Md06, label: "MD 06" },
      { id: "md07", component: Md07, label: "MD 07" },
      { id: "md08", component: Md08, label: "MD 08" },
      { id: "md09", component: Md09, label: "MD 09" },
      { id: "md10", component: Md10, label: "MD 10" },
      { id: "md11", component: Md11, label: "MD 11" },
      { id: "md12", component: Md12, label: "MD 12" },
      { id: "md13", component: Md13, label: "MD 13" },
      { id: "md14", component: Md14, label: "MD 14" },
      { id: "md15", component: Md15, label: "MD 15" },
      { id: "md16", component: Md16, label: "MD 16" },
      { id: "md17", component: Md17, label: "MD 17" },
      { id: "md18", component: Md18, label: "MD 18" },
      { id: "md19", component: Md19, label: "MD 19" },
      { id: "md20", component: Md20, label: "MD 20" },
    ],
  },

  // 7. KD57200 WHITE DZIECI (PDF-y mają 223x300 mm; KD14 pominięty — brak tekstów w PDF)
  {
    id: "kd57200",
    title: "KD57200 White Dzieci (223x300)",
    basePath: "/KD57200_WHITE_dzieci_223x250",
    thumbnailRatio: { width: 223, height: 300 },
    covers: [
      { id: "kd01", component: Kd01, label: "KD 01" },
      { id: "kd02", component: Kd02, label: "KD 02" },
      { id: "kd03", component: Kd03, label: "KD 03" },
      { id: "kd04", component: Kd04, label: "KD 04" },
      { id: "kd05", component: Kd05, label: "KD 05" },
      { id: "kd06", component: Kd06, label: "KD 06" },
      { id: "kd07", component: Kd07, label: "KD 07" },
      { id: "kd08", component: Kd08, label: "KD 08" },
      { id: "kd09", component: Kd09, label: "KD 09" },
      { id: "kd10", component: Kd10, label: "KD 10" },
      { id: "kd11", component: Kd11, label: "KD 11" },
      { id: "kd12", component: Kd12, label: "KD 12" },
      { id: "kd13", component: Kd13, label: "KD 13" },
      { id: "kd15", component: Kd15, label: "KD 15" },
      { id: "kd16", component: Kd16, label: "KD 16" },
      { id: "kd17", component: Kd17, label: "KD 17" },
      { id: "kd18", component: Kd18, label: "KD 18" },
      { id: "kd19", component: Kd19, label: "KD 19" },
      { id: "kd20", component: Kd20, label: "KD 20" },
    ],
  },

  // 8. KD463002 WHITE 190x253 mm. PDF-y projektanta mają 190x250 mm (poza WZ28): tła są
  //    rozciągnięte w pionie o 1,2% (preserveAspectRatio="none"), a pozycje w pionie
  //    przeskalowane 253/250, żeby przy druku nie zostawała biała ramka.
  {
    id: "kd463002",
    title: "KD463002 White (190x253)",
    basePath: "/KD463002WHITE_190x253",
    thumbnailRatio: { width: 190, height: 253 },
    covers: [
      { id: "wz21", component: Wz21, label: "WZ 21" },
      { id: "wz22", component: Wz22, label: "WZ 22" },
      { id: "wz23", component: Wz23, label: "WZ 23" },
      { id: "wz24", component: Wz24, label: "WZ 24" },
      { id: "wz25", component: Wz25, label: "WZ 25" },
      { id: "wz26", component: Wz26, label: "WZ 26" },
      { id: "wz27", component: Wz27, label: "WZ 27" },
      { id: "wz28", component: Wz28, label: "WZ 28" },
      { id: "wz29", component: Wz29, label: "WZ 29" },
      { id: "wz30", component: Wz30, label: "WZ 30" },
      { id: "wz31", component: Wz31, label: "WZ 31" },
      { id: "wz32", component: Wz32, label: "WZ 32" },
      { id: "wz33", component: Wz33, label: "WZ 33" },
      { id: "wz34", component: Wz34, label: "WZ 34" },
      { id: "wz35", component: Wz35, label: "WZ 35" },
      { id: "wz36", component: Wz36, label: "WZ 36" },
      { id: "wz112", component: Wz112, label: "WZ 112" },
      { id: "wz113", component: Wz113, label: "WZ 113" },
      { id: "wz114", component: Wz114, label: "WZ 114" },
      { id: "wz115", component: Wz115, label: "WZ 115" },
      { id: "wz116", component: Wz116, label: "WZ 116" },
      { id: "wz117", component: Wz117, label: "WZ 117" },
      { id: "wz118", component: Wz118, label: "WZ 118" },
      { id: "wz119", component: Wz119, label: "WZ 119" },
      { id: "wz120", component: Wz120, label: "WZ 120" },
      { id: "wz121", component: Wz121, label: "WZ 121" },
      { id: "wz122", component: Wz122, label: "WZ 122" },
      { id: "wz123", component: Wz123, label: "WZ 123" },
      { id: "wz124", component: Wz124, label: "WZ 124" },
      { id: "wz125", component: Wz125, label: "WZ 125" },
      { id: "wz126", component: Wz126Kd463002, label: "WZ 126" },
      { id: "wz127", component: Wz127, label: "WZ 127" },
      { id: "wz128", component: Wz128, label: "WZ 128" },
      { id: "wz129", component: Wz129, label: "WZ 129" },
      { id: "wz130", component: Wz130, label: "WZ 130" },
      { id: "wz131", component: Wz131, label: "WZ 131" },
      { id: "wz132", component: Wz132, label: "WZ 132" },
      { id: "wz133", component: Wz133, label: "WZ 133" },
      { id: "wz134", component: Wz134, label: "WZ 134" },
      { id: "wz135", component: Wz135, label: "WZ 135" },
      { id: "wz136", component: Wz136, label: "WZ 136" },
      { id: "wz137", component: Wz137, label: "WZ 137" },
      { id: "wz138", component: Wz138, label: "WZ 138" },
      { id: "wz139", component: Wz139, label: "WZ 139" },
      { id: "wz140", component: Wz140, label: "WZ 140" },
    ],
  },
  {
    id: "kd46500",
    title: "KD46500/600 White Baby (330x333)",
    basePath: "/KD46500_600_WHITE_BABY_330x333",
    thumbnailRatio: { width: 330, height: 333 },
    covers: [
      { id: "cd01", component: Cd01, label: "CD 01" },
      { id: "cd02", component: Cd02, label: "CD 02" },
      { id: "cd03", component: Cd03, label: "CD 03" },
      { id: "cd04", component: Cd04, label: "CD 04" },
      { id: "cd05", component: Cd05, label: "CD 05" },
      { id: "cd06", component: Cd06, label: "CD 06" },
      { id: "cd07", component: Cd07, label: "CD 07" },
      { id: "cd08", component: Cd08, label: "CD 08" },
      { id: "cd09", component: Cd09, label: "CD 09" },
      { id: "cd10", component: Cd10, label: "CD 10" },
      { id: "cd11", component: Cd11, label: "CD 11" },
      { id: "cd12", component: Cd12, label: "CD 12" },
      { id: "cd13", component: Cd13, label: "CD 13" },
      { id: "cd14", component: Cd14, label: "CD 14" },
      { id: "cd15", component: Cd15, label: "CD 15" },
      { id: "cd16", component: Cd16, label: "CD 16" },
      { id: "cd17", component: Cd17, label: "CD 17" },
      { id: "cd18", component: Cd18, label: "CD 18" },
      { id: "cd19", component: Cd19, label: "CD 19" },
      { id: "cd20", component: Cd20, label: "CD 20" },
      { id: "cd21", component: Cd21, label: "CD 21" },
      { id: "cd22", component: Cd22, label: "CD 22" },
      { id: "cd24", component: Cd24, label: "CD 24" },
      { id: "cd25", component: Cd25, label: "CD 25" },
      { id: "cd26", component: Cd26, label: "CD 26" },
      { id: "cd27", component: Cd27, label: "CD 27" },
      { id: "cd28", component: Cd28, label: "CD 28" },
      { id: "cd29", component: Cd29, label: "CD 29" },
      { id: "cd30", component: Cd30, label: "CD 30" },
      { id: "cd31", component: Cd31, label: "CD 31" },
      { id: "cd32", component: Cd32, label: "CD 32" },
      { id: "cd33", component: Cd33, label: "CD 33" },
      { id: "cd34", component: Cd34, label: "CD 34" },
      { id: "cd35", component: Cd35, label: "CD 35" },
      { id: "cd36", component: Cd36, label: "CD 36" },
      { id: "cd37", component: Cd37, label: "CD 37" },
      { id: "cd38", component: Cd38, label: "CD 38" },
      { id: "cd39", component: Cd39, label: "CD 39" },
      { id: "cd40", component: Cd40, label: "CD 40" },
      { id: "cd41", component: Cd41, label: "CD 41" },
      { id: "cd42", component: Cd42, label: "CD 42" },
      { id: "cd43", component: Cd43, label: "CD 43" },
      { id: "cd44", component: Cd44, label: "CD 44" },
      { id: "cd45", component: Cd45, label: "CD 45" },
      { id: "cd46", component: Cd46, label: "CD 46" },
      { id: "cd47", component: Cd47, label: "CD 47" },
      { id: "cd48", component: Cd48, label: "CD 48" },
    ],
  },
];
